export default {
	leads: 'Moje příležitosti',
	marketPlaceFilter: 'Filtrovací kritéria',
	fullNameOrBussinessName: 'Jméno / Název klienta',
	processed: 'Zpracováno',
	isClientInCampaign: 'Klient v kampani',
	phone: 'Telefon',
	email: 'Email',
	municipality: 'Obec',
	zipCode: 'PSČ',
	birthdateNumberAndBusinessIn: 'Rodné číslo / IČO',
	opportunityType: 'Název příležitosti',
	opportunitySubtype: 'Podtyp příležitosti',
	subordinateLeads: 'Příležitosti podřízených',
	policyNo: 'Číslo PS',
	marketPlaceLeadsTitle: 'Tržiště',
	takeLead: 'Převzít',
	noAvailableLeadsToTake: 'V tržišti není žádná nová příležitost k převzetí.',
	expiration: 'Expirace',
	hot: 'Hot',
	current: 'Aktuální',
	future: 'Budoucí',
	inProgress: 'Rozpracováno',
	inProgressOrAfterDeadline: 'Zpracováno / Po termínu',
	amount: 'Počet',
	confirmFeedbackMsg: 'Opravdu si přejete zadat vybranou zpětnou vazbu?',
	tooManyResults: 'V seznamu nelze zobrazit více jak 200 příležitostí',

	taskType: 'Název příležitosti',
	taskSubTypeId: 'Podtyp příležitosti',
	surname: 'Příjmení',
	firstName: 'Jméno',
	businessName: 'Název',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	slaIconText: 'Pokud nezpracujete příležitost v určeném termínu, bude vrácena zpět do tržiště.',
};
